import { configureStore, combineReducers } from '@reduxjs/toolkit';
import cnameReducer  from './Cname';
import scReducer from './SharingContent';
import prizeReducer from './Prize';
import fraudReducer from './Fraud';
import automationReducer  from './Automation';
import abReducer from './ActionBuilder';
import profileReducer from './Profile';
import leReducer from './LiveEditor';
import builderReducer from './Builder';
import mlrReducer from './Mailer';
import templateSettingsReducer from './TemplateSettings'; // Add this line



const appStore = configureStore({
    reducer: {
        cname: cnameReducer,
        pc: prizeReducer,
        fa: fraudReducer,
        ac: automationReducer,
        ab: abReducer,
        le: leReducer,
        me: profileReducer,
        sc: scReducer,
        mlr: mlrReducer,
        builder: builderReducer,
        template: templateSettingsReducer,
    },
});

export { storeCampaigns }  from './Campaigns';
export { storeCampaign }  from './Campaign';

export { storePerkXi } from "./PerkXi";
export { storePerkXiInterpolation } from "./PerkXiInterpolation";

export {
    appStore
};
